var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowTqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 9.50068V10.8936C8.9161 10.7462 8.46737 10.666 7.99984 10.666C5.7907 10.666 3.99984 12.4569 3.99984 14.666H2.6665C2.6665 11.7205 5.05432 9.33268 7.99984 9.33268C8.46024 9.33268 8.90704 9.39102 9.33317 9.50068ZM7.99984 8.66602C5.78984 8.66602 3.99984 6.87602 3.99984 4.66602C3.99984 2.45602 5.78984 0.666016 7.99984 0.666016C10.2098 0.666016 11.9998 2.45602 11.9998 4.66602C11.9998 6.87602 10.2098 8.66602 7.99984 8.66602ZM7.99984 7.33268C9.47317 7.33268 10.6665 6.13935 10.6665 4.66602C10.6665 3.19268 9.47317 1.99935 7.99984 1.99935C6.5265 1.99935 5.33317 3.19268 5.33317 4.66602C5.33317 6.13935 6.5265 7.33268 7.99984 7.33268ZM11.8618 13.2755L14.2188 10.9185L15.1616 11.8613L11.8618 15.1611L9.50477 12.8041L10.4476 11.8613L11.8618 13.2755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowTqIcon);
export default __webpack_public_path__ + "static/media/follow-tq-icon.32b0132763a253d4a492a7e8b31e6418.svg";
export { ForwardRef as ReactComponent };